/**
* Rep Finder Form JS
* -----------------------------------------------------------------------------
*
* All the JS for the Rep Finder Form component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'rep-finder-form',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const _this = this;
      $( 'form.rep-finder' ).on( 'submit', function( e ) {
        e.preventDefault();
        _this.findRep();
        return false;
      } );
      _this.getSubCategoryInput();
      $( '#rep-finder_country' ).on( 'change', function() {
        _this.getSubCategoryInput();
      } );
      $( '#rep-finder-popup__close' ).on( 'click', function() {
        $( '#rep-form-results__popup-wrapper' ).removeClass( 'is-open' );
      } );
    },
    finalize: function() {
    },
    findRep: function() {
      const location = $( '#rep-finder_country option:selected' ).val();
      const state = $( '#rep-finder__state option:selected' ).val();
      const data = {
        location,
        state,
      };

      $.ajax( {
        type: 'GET',
        url: siteInfo.wpApiSettings.ll + 'rep/finder',
        data: data,
        beforeSend: function( xhr ) {
          xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
          xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
          doingAjax = true;
          $( '.find-a-rep-form__form-container' ).addClass( 'doing-ajax' );
        },
        success: function( response ) {
          if ( response ) {
            $( '#rep-form-results__popup' ).html( response );
            $( '#rep-form-results__popup-wrapper' ).addClass( 'is-open' );
          }
        },
        complete: function( jqXHR, status ) {
          doingAjax = false;
          $( '.find-a-rep-form__form-container' ).removeClass( 'doing-ajax' );
        },
      } );
    },
    getSubCategoryInput: function() {
      const location = $( '#rep-finder_country option:selected' ).val();
      $.ajax( {
        type: 'GET',
        url: siteInfo.wpApiSettings.root + 'wp/v2/ll_representative_location',
        data: {
          parent: location,
          hide_empty: true,
          per_page: 100,
        },
        beforeSend: function( xhr ) {
          doingAjax = true;
          $( '.find-a-rep-form__form-container' ).addClass( 'doing-ajax' );
        },
        error: function( response ) {
          console.log( response );
        },
        success: function( data ) {
          $( '#rep-finder__state option' ).not( '[value=""]' ).remove();
          if ( data.length > 0 ) {
            $( '#rep-finder__state' ).removeClass( 'hidden' );
            data.forEach( function( category ) {
              console.log( category );
              $( '#rep-finder__state select' ).append(
                  $( '<option>', {
                    value: category.id,
                    text: category.name,
                  } ),
              );
            } );
          } else {
            $( '#rep-finder__state' ).addClass( 'hidden' );
          }
        },
        complete: function( jqXHR, status ) {
          console.log( 'complete' );
          doingAjax = false;
          $( '.find-a-rep-form__form-container' ).removeClass( 'doing-ajax' );
        },
      } );
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'rep-finder-form', COMPONENT );
} )( app );
